// extracted by css-extract-rspack-plugin
export default {"header":"header-L6MRsC","title":"title-RfOpu3","count":"count-ZHU4XO","spacer":"spacer-cP_Anl","tools":"tools-rjLL3I","body":"body-WKm_Hx"};